import { connect } from 'react-redux';

import TeamsView from './TeamsView.jsx';
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';

import { fetchIntegrations, getIntegrationForType } from "src/legacy/redux/actions/integrations.jsx";
import { authenticateAccount, beginTeamsAuthentication, updateTeamsRecordingToggle } from 'src/legacy/redux/actions/integrations/teamsIntegration.jsx';


const mapStateToProps = (state, ownProps) => {
    let integration = getIntegrationForType(state, 'teams');
    return {
        user: state.users.me,
        integration: integration,
        integrations: state.legacyRootReducer.settings.integrations,
        authenticating: state.legacyRootReducer.settings.integrations.teams.authentication.authenticating,
        deactivating: state.legacyRootReducer.settings.integrations.activated.deactivating.loading,
        error: state.legacyRootReducer.settings.integrations.teams.authentication.error,
        enabled: state.legacyRootReducer.settings.integrations.teams.recordingEnabled.enabled,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        authenticateAccount: (code, type) => {
            return dispatch(authenticateAccount(code, type));
        },

        beginTeamsAuthentication: () => {
            return dispatch(beginTeamsAuthentication());
        },

        fetchIntegrations: () => {
            return dispatch(fetchIntegrations());
        },
        
        updateTeamsRecordingToggle: (enabled) => {
            return dispatch(updateTeamsRecordingToggle(enabled));
        }
    }
}

const TeamsPage = connect(
    mapStateToProps,
    mapDispatchToProps
)(TeamsView);

export default withUseHooks(TeamsPage);
